import { GuxFormFieldTextarea } from "genesys-spark-components-react";
import { useStrings } from "features/i18n/useStrings";
import {
    scorableSliceActions,
    selectQuestionScore,
    sendAnswersDataOnFormDataChange,
} from "features/scorable/scorableSlice";
import { selectQuestion } from "features/qualityForm/qualityFormSlices/qualityFormCommons";

import "./FreeTextQuestionOption.less";
import strings from "./FreeTextQuestionOption.strings";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { shallowEqual } from "react-redux";
import { selectIsFreeTextAnswerValid } from "features/scorable/ScorableFormValidations";
import { useContext } from "react";
import { ScorableValidationContext } from "../Contexts";
import { RemainingCharacters } from "../RemainingCharacters";

export default function FreeTextQuestionOption({
    questionId,
    disabled,
}: {
    questionId: string;
    disabled?: boolean;
}) {
    const t = useStrings(strings);
    const dispatch = useAppDispatch();
    const { showValidationErrors } = useContext(ScorableValidationContext);
    const freeTextAnswer = useAppSelector((state) => {
        const score = selectQuestionScore(state, questionId);
        return score?.freeTextAnswer ?? "";
    });
    const { maxCharacters, naEnabled } = useAppSelector((state) => {
        const question = selectQuestion(state, questionId);
        return {
            maxCharacters: question?.maxResponseCharacters ?? 0,
            naEnabled: question?.naEnabled ?? false,
        };
    }, shallowEqual);
    const isFreeTextAnswerInvalid = useAppSelector(
        (state) =>
            showValidationErrors &&
            !selectIsFreeTextAnswerValid(state, questionId)
    );
    return (
        <div className="FreeTextQuestionOption">
            <GuxFormFieldTextarea
                data-invalid={isFreeTextAnswerInvalid === true}
                resize="auto"
                labelPosition="screenreader"
            >
                <label slot="label">
                    {disabled ? t.labels.readOnlyTextArea : t.labels.textArea}
                </label>
                <textarea
                    slot="input"
                    name="textarea"
                    value={freeTextAnswer}
                    placeholder={disabled ? "" : t.labels.textArea}
                    onChange={({ currentTarget }) => {
                        const setFreeTextAnswer = () => {
                            dispatch(
                                scorableSliceActions.setFreeTextAnswer({
                                    questionId: questionId,
                                    text: currentTarget.value,
                                    naEnabled,
                                })
                            );
                        };
                        dispatch(
                            sendAnswersDataOnFormDataChange(setFreeTextAnswer)
                        );
                    }}
                    readOnly={disabled}
                    aria-readonly={disabled}
                    tabIndex={disabled ? -1 : 0}
                ></textarea>
                {freeTextAnswer.length > maxCharacters && (
                    <span slot="error" role="alert">
                        {t.labels.error({
                            total: maxCharacters,
                        })}
                    </span>
                )}
            </GuxFormFieldTextarea>
            {!disabled && (
                <RemainingCharacters
                    currentCount={freeTextAnswer.length}
                    totalCount={maxCharacters}
                />
            )}
        </div>
    );
}
